import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRICE_BEFORE, offerIncludes, offerRows } from '../data/liikunta';
import { PRODUCT_IMAGE } from '../data/assets';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-235" data-mp="1mpd665oe037z">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-236" data-mp="1hqs4s2xefdhy">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-237" data-mp="u0xsbmgzrqy8">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-238" data-mp="p0jxj64eidi5">
            Alt i <em className="whitespace-nowrap text-red-300" style={{
            hyphens: 'manual'
          }} data-id="element-239" data-mp="13xau77moxb42">IDRÆT KLAR™</em> – samlet i én pakke
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-240" data-mp="ywmyw9rfi841">
            Hele året i idræt – færdigplanlagt. Klar til idrætshallen på 5 minutter.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-241" data-mp="2acblv14on74u" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-242" data-mp="pml89msvtjdb">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-243" data-mp="zjg6s5p5njrl">Hele pakken indeholder</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-244" data-mp="13k9vv2ec34m2">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-245" data-mp="6usis2d0ugac">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-246" data-mp="bskihijwr6p3">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-247" data-mp="fu5qoqlhywsy" />
                </span>
                <span data-id="element-248" data-mp="klxkd9zy9inb">
                  <span className="block font-medium leading-snug" data-id="element-249" data-mp="kmfdhxrbfgr0">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-250" data-mp="3k847g5djq2yc">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-251" data-mp="vf7c0ci2k89y">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-252" data-mp="qgdyik2s8h9s">Introduktionspris <s className="ml-1 text-slate-900/50" data-id="element-253" data-mp="1548se3sj0rog">{PRICE_BEFORE}</s></p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-254" data-mp="105xjpwdywn7t">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-255" data-mp="ciz5749erpcj">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-256" data-mp="7k4nk5n6g6u0" />
            Engangsbetaling. Intet abonnement.
          </p>

          <CtaButton label="Få hele pakken nu" className="mt-8 w-full" data-id="element-257" data-mp="hfg3grabnk3c" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-258" data-mp="hibzub6iu0po">
            {offerIncludes.map(item => <li key={item} data-id="element-259" data-mp="1svwdg533x8it">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}